import { signOutOfFirebase } from '../config/firebase';
import { handleClearProductLoaded } from './localStorage';
import { clearAccessToken } from './accessTokenStore';

/**
 * Single logout path for the app.
 *
 * The Firebase sign-out is not optional: that session auto-refreshes
 * indefinitely, so without it a logged-out tab keeps a live authenticated
 * database connection, and the next user to log in on this browser would
 * inherit the previous user's Firebase identity.
 *
 * Firebase sign-out runs first but never blocks the local teardown — losing the
 * access token matters more than a clean Firebase exit if something goes wrong.
 */
const logout = async ({ reload = true } = {}) => {
  // Not awaited: this used to block the teardown below on the Firebase round trip, so a slow
  // or hung sign-out delayed the reload by however long that took, with nothing on screen
  // explaining the wait — exactly the "doesn't auto-refresh" symptom this was meant to avoid.
  signOutOfFirebase().catch((e) => {
    console.error('Firebase sign-out failed during logout:', e);
  });

  clearAccessToken();
  // Legacy key from before access tokens moved to in-memory storage — unread now, but purge it
  // so it doesn't linger for users who logged in before this change.
  localStorage.removeItem('@access_token');
  localStorage.removeItem('otp_verified');
  localStorage.removeItem('@refresh_token');
  handleClearProductLoaded();

  if (reload) {
    window.location.reload(true);
  }
};

export default logout;
